import SubscriptionsSelector from '../SubscriptionsSelector'
import { systemRequirementsUrl } from '../../constants'


export default ({ t, i18n, mdarsProducts, cart, addToCart, setSubscription, subscription, language }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle')}</h4>
    <div className="m-b-md">
      {t('common:mdars-page-content-7')}
      <div className="columns">
        <div className="column is-4">
        <ul>
            <li>{t('common:mdars-page-content-23')}</li>
            <li>{t('common:mdars-page-content-22')}</li>
            <li>{t('common:mdars-page-content-24')}</li>                    
            <li>{t('common:mdars-page-content-36')}</li>                    
          </ul>
        </div>
        <div className="column is-4">
          <ul>          
            <li>{t('common:mdars-page-content-21')}</li>                    
            <li>{t('common:mdars-page-content-20')}</li>
            <li>{t('common:mdars-page-content-18')}</li>
            <li>{t('common:mdars-page-content-37')}</li>            
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-17')}</li>          
            <li>{t('common:mdars-page-content-9')}</li>
         <li>{t('common:mdars-page-content-8')}</li>
            <li>{t('common:mdars-page-content-38')}</li>            
        </ul>
        </div>
      </div>      
      <div>{t('common:mdars-page-content-2')}</div>
        <ul>
          <li>{t('common:mdars-page-content-10')}</li>
        </ul>        
    </div>
    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-13')}</li>
        <li>{t('common:mdars-page-content-1')}</li>
        <li>{t('common:mdars-page-content-14')}</li>
        <li>{t('common:mdars-page-content-4')}</li>
      </ul>
    </div>
    <SubscriptionsSelector
      products={mdarsProducts}
      subscription={subscription}
      setSubscription={setSubscription}
      addToCart={addToCart}
      cart={cart}
      language={language}
      t={t} />
    <div className="m-b-md">
      {t('common:ids-page-content-8')}&nbsp;
      <a href={systemRequirementsUrl(i18n.language)}
        target="_blank">
        {t('common:click-here')}
      </a>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/MDARSSoftware/index.js